import { render, staticRenderFns } from "./DevelopLook.vue?vue&type=template&id=3b0d3b5f&scoped=true&"
import script from "./DevelopLook.vue?vue&type=script&lang=js&"
export * from "./DevelopLook.vue?vue&type=script&lang=js&"
import style0 from "./DevelopLook.vue?vue&type=style&index=0&id=3b0d3b5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0d3b5f",
  null
  
)

export default component.exports